'use client';

import { useEffect } from 'react';

import { unlockCalendlyPage } from '@/services/integrations/calendly/Calendly.scroll-lock';

/**
 * Keeps the application scroll-lock state synchronized
 * with the Calendly popup lifecycle.
 */
const CalendlyPopupSync = () => {
  useEffect(() => {
    let hasSeenCalendlyOverlay = false;

    const observer = new MutationObserver(() => {
      const overlay = document.querySelector('.calendly-overlay');

      /**
       * Calendly popup has appeared.
       */
      if (overlay) {
        hasSeenCalendlyOverlay = true;

        return;
      }

      /**
       * Ignore mutations before Calendly has actually opened.
       */
      if (!hasSeenCalendlyOverlay) {
        return;
      }

      /**
       * Calendly existed previously but is now gone.
       * Restore the original document position.
       */
      hasSeenCalendlyOverlay = false;

      unlockCalendlyPage();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();

      unlockCalendlyPage();
    };
  }, []);

  return null;
};

export default CalendlyPopupSync;
